import { render, staticRenderFns } from "./segmented-button.vue?vue&type=template&id=2d9686f4&scoped=true&"
import script from "./segmented-button.vue?vue&type=script&lang=js&"
export * from "./segmented-button.vue?vue&type=script&lang=js&"
import style0 from "./segmented-button.vue?vue&type=style&index=0&id=2d9686f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9686f4",
  null
  
)

export default component.exports